<template>
    <div class="reportParent margin-top">
      <div class="layout-box-white-bg-ig6pe">
          <div class="simple-2S7p1">
              <span class="title">家长德育报告</span>
              <p class="update-time">报告数据每天早上9点左右更新</p>
          </div>
          <div class="filter-panel">
              <div class="item">
                  <span class="label">子女年级：</span>
                  <el-select v-model="value" placeholder="全部" @change="getSelectOne(value)">
                      <el-option
                              v-for="item in Grade"
                              :key="item.graduateYear"
                              :label="item.gradeName"
                              :value="item.graduateYear">
                      </el-option>
                  </el-select>
              </div>
              <div class="item">
                  <span class="label">周期：</span>
                  <el-select v-model="value" placeholder="全部" @change="getSelectOne(value)">
                      <el-option
                              v-for="item in Grade"
                              :key="item.graduateYear"
                              :label="item.gradeName"
                              :value="item.graduateYear">
                      </el-option>
                  </el-select>
              </div>
          </div>
          <section class="custom-caption">
              <span class="title">各班级家长看课情况</span>
              <el-popover
                      placement="right"
                      width="400"
                      trigger="click">
                  <p>
                      看课家长数：观看过家长课程的人数
                  </p>
                  <p>
                      看课总节数：观看完成的家长课程的总节数
                  </p>
                  <p>
                      看课总时长：观看家长课程的实际观看时长总和
                  </p>
                  <i slot="reference" class="el-icon-warning-outline"></i>
              </el-popover>
          </section>
          <div class="custom-table">
              <el-table
                      :data="tableData"
                      border
                      :header-cell-style="{
                                        'background-color': '#f5f8ff',
                                        'color': '#000',
                                        'font-weight': '400'
                                    }"
                      style="width: 100%">
                  <el-table-column
                          prop="name"
                          label="班级"
                  >
                  </el-table-column>
                  <el-table-column
                          prop="categoryName"
                          label="看课家长数"
                  >
                  </el-table-column>
                  <el-table-column
                          prop="teacherName"
                          label="看课总节数">
                  </el-table-column>
                  <el-table-column
                          prop="teacherName"
                          label="看课总时长（分钟）">
                  </el-table-column>

              </el-table>
          </div>
          <section class="custom-caption">
              <span class="title">全校课程情况</span>


              <el-popover
                      placement="right"
                      width="400"
                      trigger="click">
                  <p>
                      近1个月看课家长数：全校家长观看的视频课程中，某课程近1个月观看的家长数
                  </p>
                  <p>
                      累计看课家长数：全校家长观看的视频课程中，某课程累计观看的家长数
                  </p>
                  <i slot="reference" class="el-icon-warning-outline"></i>
              </el-popover>
          </section>
          <div class="custom-table">
              <el-table
                      :data="tableData"
                      border
                      :header-cell-style="{
                                        'background-color': '#f5f8ff',
                                        'color': '#000',
                                        'font-weight': '400'
                                    }"
                      style="width: 100%">
                  <el-table-column
                          prop="name"
                          label="课程名称（前十名）"
                  >
                  </el-table-column>
                  <el-table-column
                          prop="categoryName"
                          label="近一个月看课家长数"
                  >
                  </el-table-column>
                  <el-table-column
                          prop="teacherName"
                          label="累计看课家长数">
                  </el-table-column>


              </el-table>
          </div>


      </div>
    </div>
</template>

<script>
    import{
        teacherGrades
    } from '../../../config/index'
    export default {
        name: "reportParent",
        data(){
            return{
                value: '',
                Grade:[],
                tableData:[],
            }
        },
        methods:{
          async getTeacherGrades(){
                let res = await teacherGrades();
                if (res.status){
                    this.Grade = res.data;
                }
            },
            getSelectOne(val){
              console.log(val);
            }
        },
        created() {
            this.getTeacherGrades();
        }
    }
</script>

<style scoped lang="scss">
.reportParent{
    .layout-box-white-bg-ig6pe{
        background-color: #fff;
        padding: 0 32px 32px 32px;
        .simple-2S7p1{
            border-bottom: 1px solid #E6EAF5;
            font-size: 18px;
            padding: 22px 0;
            color: #373a44;
            position: relative;
            margin-bottom: 16px;
            .update-time {
                font-size: 14px;
                color: #FF9631;
                margin-left: 13px;
                display: inline-block;
            }
        }
        .filter-panel{

            font-size: 14px;
            color: #7c89a7;
            padding: 8px 0 24px;
            .item{
                margin-right: 24px;
                display: inline-block;
            }
        }
        .custom-caption {
            font-size: 18px;
            height: 32px;
            color: #373a44;
            position: relative;
            margin-bottom: 16px;
           .title {
               font-weight: 600;
                line-height: 32px;
               padding-left: 12px;
               border-left: 3px solid #1A83FF;
            }
        }
        .custom-table{
            margin-bottom: 30px;
        }
    }

}
</style>
